// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_ujd","cls2":"LoswpPackPitch-cls2__hn LoswpPackPitch-cls1_ujd"};